import get from 'lodash/get';

import { FullscreenLoader } from './fullscreenLoader';

export const FullscreenLoaderService = angular
    .module('checkout.components.fullscreenLoader.service', [
        FullscreenLoader
    ]).service('loadingService', ($rootScope) => {
        let storeInfo;

        $rootScope.loader = {};

        function setStoreInfo(info) {
            storeInfo = info;
        }

        function show(text) {
            const loaderAlreadyActive = $rootScope.loader.show;
            $rootScope.loader = {
                show: true,
                imageUri: get(storeInfo, 'logo.imageLink.fullUri'),
                titleText: loaderAlreadyActive && text ? text : get(storeInfo, 'name'),
                description: loaderAlreadyActive ? $rootScope.loader.description : text
            };
        }

        function hide() {
            $rootScope.loader = { show: false };
        }

        return {
            show,
            hide,
            setStoreInfo
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/fullscreenLoader/fullscreenLoader.service.js